import { render, staticRenderFns } from "./ReservationPolicy.vue?vue&type=template&id=81acf7d0"
import script from "./ReservationPolicy.vue?vue&type=script&lang=js"
export * from "./ReservationPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports